import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { timeOffService } from '../api/time-off.service';
import { TIME_OFF_KEYS } from './queryKeys';
import type { RejectTimeOffRequestPayload } from '../types';

/** Current step's approver only. */
export function useRejectTimeOffRequest() {
  const queryClient = useQueryClient();
  const orgId = useOrganizationStore((s) => s.activeOrganizationId)!;

  return useMutation({
    mutationFn: ({
      requestId,
      payload,
    }: {
      requestId: string;
      payload: RejectTimeOffRequestPayload;
    }) => timeOffService.rejectRequest(requestId, payload),
    onSuccess: (_data, { requestId }) => {
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.request(orgId, requestId) });
      queryClient.invalidateQueries({ queryKey: TIME_OFF_KEYS.approvals(orgId) });
      queryClient.invalidateQueries({ queryKey: ['time-off', 'team', orgId] });
      queryClient.invalidateQueries({ queryKey: ['time-off', 'admin'] });
    },
  });
}
